import React, { useState } from "react";
import { Images } from "../../../Controller";
import { Button, Input, Modal, Spin, Table, Tag, Tooltip } from "antd";
import {
  CaretRightOutlined,
  CheckCircleFilled,
  DeleteColumnOutlined,
  DeleteFilled,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import {
  beneficiaryDelete,
  beneficiaryXPayDelete,
  getRemittersXPay,
} from "../../../ApiServices/Apifun";
import VerifyModal from "../../../Common/VerifyModal";
import { Globalendpoints } from "../../../ApiServices/global";
import { BsFillTrash2Fill } from "react-icons/bs";
import { GiCancel } from "react-icons/gi";
import { dispatchtoast, trimString } from "../../../Utils";
import AddBeneFiciaryModalxPay from "./AddBeneFiciaryModalxPay";
import XPayModal from "./XPayModal";
import CommonPagination from "../../../Common/Pagination";
import { MdPayment } from "react-icons/md";
import useOtpHook from "../../../Hooks/useOtpHook";
import CommonInput from "../../../Common/CommonInput";

const BeneficiaryCardxPay = ({
  beneficiariesDetails,
  setbeneficiariesDetails,
  mobile,
  handleSearch,
  type,
  searchKeyword,
  setSearchKeyWord,
  apicall,
  account,
  remitterDetails,
  setShowNamefield,
  setMobile,
  showNameField,
  setIsVerified,
  isVerified,
}) => {
  const [showBtn, setShowBtn] = useState({
    show: false,
    index: null,
  });
  const [response, setResponse] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [bebenficiaryId, setBeneFiciaryId] = useState(null);
  const [PayBeneOpen, setPayBeneOpen] = useState({
    show: false,
    detail: null,
    transaction_type: null,
  });
  const [btnLoading, setBtnLoading] = useState(false);
  console.log(beneficiariesDetails, "beneficiariesDetails");
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [current, setCurrent] = useState(1);
  const [selecteddata, setSelectedData] = useState({});
  const [from, setFrom] = useState("add");
  const [verifyPinScreen, setverifyPinScreen] = useState(false);
  const [pendingFormValues, setPendingFormValues] = useState(null);
  const { handleChange, handleKeyUp, pin, inputRefs, resetPin } = useOtpHook(4);
  const [loader, setLoader] = useState(false);
  const ReportColumn = [
    {
      title: "Beneficiary",
      dataIndex: "beneficiary",
      key: "beneficiary",
      render: (text, record) => <a>{text}</a>,
    },
    {
      title: "Account Id",
      dataIndex: "account_id",
      key: "account_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  overflow-y-scroll">{text}</p>
          </>
        );
      },
    },
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name",
      render: (text) => (
        <p style={{ width: "100px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "IFSC code",
      dataIndex: "ifsc",
      key: "ifsc",
      render: (text) => <a>{text}</a>,
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   key: "type",
    //   render: (text) => <a>{text}</a>,
    // },

    {
      title: " Status",
      dataIndex: "is_verified",
      key: "is_verified",
      render: (text, record) => (
        <div>
          {text === "1" ? (
            <Tag color="green">
              <CheckCircleFilled /> Verified
            </Tag>
          ) : (
            <Tag color="red">
              <ExclamationCircleFilled /> Pending
            </Tag>
            // <Button
            //   loading={verifyBtnLoading === record.id}
            //   size="small"
            //   className="bg-red-500 border border-red-500 text-white"
            //   onClick={() => {
            //     handleVerifyBank(record);
            //   }}
            // >
            //   Do Verify
            // </Button>
          )}
        </div>
      ),
    },
    {
      title: "Pay",
      dataIndex: "pay",
      key: "pay",
      render: (text, record) => {
        return (
          <div
            className=" text-primary rounded-full text-center p-4 text-base font-bold"
            onClick={() => {
              setPayBeneOpen({
                show: true,
                detail: record,
                transaction_type: "IMPS",
              });
            }}
          >
            <Button size="small">IMPS ↗</Button>
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return (
          <div className="flex gap-4 justify-center">
            <DeleteOutlined
              className=" text-white bg-primary rounded-md text-center p-2 text-base font-bold"
              onClick={() => {
                setverifyPinScreen(true);
                setSelectedData(record);
              }}
            />
            <EditOutlined
              className=" text-white bg-primary rounded-md text-center p-2 text-base font-bold"
              onClick={() => {
                setIsOpen(true);
                setFrom("edit");
                setSelectedData(record);
              }}
            />
          </div>
        );
      },
    },
  ];
  const handleConfirm = () => {
    setBeneFiciaryId(selecteddata.id);
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("id", selecteddata.id);
    formdata.append("pin", pin.join(""));
    beneficiaryXPayDelete(formdata)
      .then((res) => {
        if (res.status) {
          // setResponse(res.data);
          dispatchtoast(res.message);
          apicall(searchKeyword);
          // setOpenVerifyModal(true);
          setverifyPinScreen(false);
          resetPin();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const handleGetBeneficiary = (contact) => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("type", type);
    formdata.append("search_keyword", searchKeyword);
    formdata.append("mobile_number", contact);
    getRemittersXPay(formdata)
      .then((res) => {
        if (res.status) {
          console.log(beneficiariesDetails, "benificairy details");
          setbeneficiariesDetails(res.data?.beneficiaries);
          setMobile(contact);
        } else {
          setIsVerified(false);
          // setShowNamefield(true);
          setMobile(contact);
          setbeneficiariesDetails([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setbeneficiariesDetails({});
      })
      .finally(() => setLoader(false));
  };
  return (
    <>
      <Spin spinning={loader}>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {remitterDetails?.map((i, id) => (
            <div
              key={id}
              onClick={() => handleGetBeneficiary(i?.mobile)}
              className="cursor-pointer rounded-lg border border-gray-300 bg-white p-4
                   hover:shadow-md hover:border-primary transition-all"
            >
              <div className="flex justify-between items-center">
                <p className="text-sm text-gray-500">Remitter</p>
                {i.is_verified === "0" ? (
                  <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded">
                    <ExclamationCircleFilled /> Verification Pending
                  </span>
                ) : (
                  <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded">
                    <CheckCircleFilled /> Verified
                  </span>
                )}
              </div>

              <p className="mt-2 font-semibold text-gray-800">{i?.name}</p>

              <p className="text-sm text-gray-600 mt-1">📱 {i?.mobile}</p>

              <p className="mt-3 text-sm text-primary font-medium">
                View Beneficiaries →
              </p>
            </div>
          ))}
        </div>
        <div className="flex justify-end items-center mt-2 flex-wrap">
          <p
            onClick={() => {
              setIsOpen(true);
              setFrom("add");
            }}
            className="bg-primary cursor-pointer hover:bg-primaryhover p-3 shadow-normal rounded-3xl text-bswhite"
          >
            Add Beneficiary
          </p>
        </div>
        <div className="selectionFields w-1/2   place-items-start ">
          <div className="w-full">
            <p className={`required text-textGray `}>Keyword</p>

            <CommonInput
              placeholder="Seacrh"
              value={searchKeyword}
              onChange={(e) => setSearchKeyWord(e.target.value)}
              className="outline-none text-xs rounded-lg border mt-4 w-full  border-gray-200 focus:border-primary   px-2 "
            />
          </div>
        </div>
        <div className="  place-items-center">
          {beneficiariesDetails && beneficiariesDetails?.length !== 0 && (
            <div className=" relative animate-fade-in  w-full py-3  ">
              <Table
                className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
                columns={ReportColumn}
                pagination={false}
                dataSource={beneficiariesDetails}
              />
              <div className="mt-2 mb-8 flex justify-end items-center">
                <CommonPagination
                  totalPages={totalPages}
                  current={current}
                  pageSize={pageSize}
                  setCurrent={setCurrent}
                  setPageSize={setPageSize}
                />
              </div>

              {/* <div className="text-white ml-8 mb-4">
                  <img src={Images.circleShape} alt="circle" />
                  <Tooltip title={i.name} arrow={false}>
                    <p className="text-md md:text-xl mt-1 cursor-pointer">
                      {trimString(i.name, 15)}
                    </p>
                  </Tooltip>
                  <p className="text-md">Beneficiary Name. {i.beneficiary}</p>
                  <p className="text-md">Remitter. {i.remitter}</p>
                  <p className="text-md">Acc No. {i.account_id}</p>
                  <p className="text-md mt-3">IFSC: {i.ifsc}</p>
                </div> */}

              {/* <p className="absolute top-4 right-6 text-white text-lg cursor-pointer">
                  <DeleteFilled
                    onClick={() => setShowBtn({ show: !showBtn.show, index })}
                  />
                </p> */}
              {/* <div
                  onClick={() => setPayBeneOpen({ show: true, detail: i })}
                  className=" hover:shadow-2xl hover:bg-green-600  hover:text-white w-1/4 md:w-1/4 absolute bottom-0 right-0 float-right transition-all cursor-pointer   flex justify-around i gap-x-4 p-2 bg-bswhite rounded-tl-3xl"
                >
                  <p className="font-semibold">Pay</p>
                </div>
                {showBtn.show && showBtn.index === index && (
                  <div className="flex absolute bottom-4 animate-slide-in mt-14 gap-4 justify-start items-center">
                    <Button
                      onClick={() => setShowBtn({ show: false, index: null })}
                      className="border-none ml-4 bg-bswhite font-semibold hover:bg-red-600 hover:text-white transition-all"
                    >
                      <GiCancel />
                    </Button>
                    <Button
                      loading={btnLoading}
                      onClick={() => handleConfirm(i)}
                      className="border-none bg-bswhite flex justify-center items-center  font-semibold hover:bg-green-600 hover:text-white transition-all"
                    >
                      <BsFillTrash2Fill />
                    </Button>
                  </div>
                )} */}
            </div>
          )}
        </div>
      </Spin>
      {openVerifyModal && (
        <VerifyModal
          isOpen={openVerifyModal}
          setIsOpen={setOpenVerifyModal}
          apicall={handleSearch}
          otherFields={{
            otp_refrence_id: response.otprefrenceid,
            beneficiary_id: bebenficiaryId,
            remitter_mobile: mobile,
          }}
          endpoint={Globalendpoints.verifyBeneficiaryDelete}
        />
      )}
      {isOpen && (
        <AddBeneFiciaryModalxPay
          mobile={mobile}
          type={type}
          isOpen={isOpen}
          handleSearch={handleSearch}
          setIsOpen={setIsOpen}
          from={from}
          setFrom={setFrom}
          selecteddata={selecteddata}
        />
      )}
      {PayBeneOpen.show && (
        <XPayModal
          referenceKey={beneficiariesDetails.reference_key}
          mobile={mobile}
          isOpen={PayBeneOpen.show}
          setIsOpen={setPayBeneOpen}
          beneficiaryId={PayBeneOpen.detail}
          details={PayBeneOpen.detail}
          remitterDetails={remitterDetails}
          transaction_type={PayBeneOpen.transaction_type}
        />
      )}
      {verifyPinScreen && (
        <Modal
          title="Enter OTP"
          open={verifyPinScreen}
          onCancel={() => {
            setverifyPinScreen(false);
            resetPin();
          }}
          footer={false}
        >
          <div className="  rounded-3xl shadow-normal bg-white p-5">
            <div className="header flex flex-col justify-center items-center">
              <p className="text-[15px] mt-3 text-gray-500">Verify PIN</p>
            </div>
            <div className=" mt-5 flex justify-center items-center">
              {[1, 2, 3, 4].map((i, index) => {
                return (
                  <input
                    key={index}
                    ref={inputRefs[index]}
                    type="text"
                    maxLength={1}
                    className="w-[25px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb bg-gray-100 h-8  mx-1 border-none  text-center"
                    value={pin[index]}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyUp={(e) => handleKeyUp(index, e)}
                  />
                );
              })}
            </div>
            <Button
              loading={btnLoading}
              onClick={() => pin.length === 4 && handleConfirm()}
              className={`SignInBtn w-full ${
                pin.length === 4 ? "cursor-pointer" : "cursor-not-allowed"
              }  mt-4 ${
                pin.length === 4 ? "bg-primary" : "bg-bsgray"
              }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
            >
              <p>Delete Beneficiary</p>
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default BeneficiaryCardxPay;
